import { render, staticRenderFns } from "./NatcashTestView.vue?vue&type=template&id=e0c89fe4&scoped=true&"
import script from "./NatcashTestView.vue?vue&type=script&lang=js&"
export * from "./NatcashTestView.vue?vue&type=script&lang=js&"
import style0 from "./NatcashTestView.vue?vue&type=style&index=0&id=e0c89fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c89fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
